
import dialogMethods from 'src/mixins/dialogMethods'
export default {
  name: 'FunctionalRoleDetail',

  mixins: [dialogMethods],

  props: {
    icon: String,
    DescrizioneRuolo: String,
    createdAt: String,
    label: { type: String, required: true },
    counterpartId: { type: Number, required: true },
  },

  data() {
    return {
      loading: false,
      counterpart: {
        RagioneSociale: null,
        label: null,
        FK_Uffici: null,
      },
    }
  },

  computed: {
    getObjLabel() { return this.$store.getters['apis/getObjLabel'] },
  },

  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    async show() {
      try {
        this.$refs.dialog.show()
        this.loading = true
        const { data } = await this.$ax.get(`counterparts/${this.counterpartId}`)
        this.counterpart = data
      } catch {
        this.$q.notify({ type: 'negative', message: `Controparte non trovato: ${this.counterpartId}` })
        // er.name = 'FunctionalRoleDetail/show'
        // throw er
      } finally { this.loading = false }
    },
  },
}
